import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PatientData } from '../components/types/patient-data';
import { RestApiService } from './rest-api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from '../components/custom/messaging/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class NavigatorService {
  constructor(private router: Router, private rest: RestApiService,
              private toast: ToastService,
              private spinner: NgxSpinnerService) {}


  /**
   * Sends a user to the appropriate home page
   *
   * @param patient    The user data.  (If empty, sends to login page.)
   * @param notALogin  Optional.  If provided and true, doesn't record this as a distinct login.
   */
  async redirectToHomePage(patient: PatientData, notALogin?:boolean) {
    try{
      if(!notALogin) {
        await this.spinner.show();
        await this.rest.recordLogin();
        await this.spinner.hide();
      }
      if(!patient) {
        return this.router.navigateByUrl("/auth/landing");
      } else if (patient.isAdmin()) {
        return this.router.navigateByUrl('/admin');
      } else if (patient.isWebHook()) {
        return this.router.navigateByUrl('/webhook/balance');
      } else {
        return this.router.navigateByUrl('/patient');
      }
    } catch(err) {
      await this.spinner.hide();
      this.toast.showDanger("Error! Can not redirect to home page.");
      console.log(this.rest.errorMessage(err));
    }
  }

  redirectToAgencyDisabled() {
    this.router.navigateByUrl("/auth/agency-disabled");
  }
}
